<template>
  <div class="inventory-list tab-table p-2">
    <InventoryTable :show-assign-to-sale="false" :exclude-header-actions="excludeHeaderActions" :selectable="false"
                    :exclude-search-fields="['receipt', 'department_uuid', 'customer_uuid', 'collected_status', 'proposal_status', 'proposal_suggestion']"
                    :extra-table-actions="extraTableActions" :exclude-item-action-buttons="['remove']"
                    :exclude-columns="['proposal_status', 'proposal_suggestion']"
    />
  </div>
</template>


<script>
  import InventoryTable from "../../InventoryTable";
  import {createNamespacedHelpers} from "vuex";
  import {
    ACTION_INVENTORY_ARCHIVE,
    ACTION_INVENTORY_BATCH_DELETE,
    ACTION_INVENTORY_CONT_AUCTION_BATCH_LOT_UP,
    ACTION_INVENTORY_CREATE_AND_DUPLICATE,
    ACTION_INVENTORY_GROUP_ITEMS,
    ACTION_INVENTORY_REMOVE_SOURCE_ITEM, ACTION_INVENTORY_RETURN_ITEMS,
    ACTION_INVENTORY_SYNC_WITH_FULCRUM,
    ACTION_INVENTORY_UNARCHIVE
  } from "@/modules/constants";

  const {mapActions, mapState} = createNamespacedHelpers('inventory');

  export default {
    name: "InventoryList",
    components: {InventoryTable},
    data() {
      return {
        excludeHeaderActions: [
          ACTION_INVENTORY_CREATE_AND_DUPLICATE,
          ACTION_INVENTORY_GROUP_ITEMS,
          ACTION_INVENTORY_CONT_AUCTION_BATCH_LOT_UP,
          ACTION_INVENTORY_SYNC_WITH_FULCRUM,
          ACTION_INVENTORY_BATCH_DELETE,
          ACTION_INVENTORY_ARCHIVE,
          ACTION_INVENTORY_UNARCHIVE,
          ACTION_INVENTORY_RETURN_ITEMS
        ],
        extraTableActions: [ACTION_INVENTORY_REMOVE_SOURCE_ITEM]
      }
    },
    computed: {
      ...mapState({
        inventory: state => state.view.currentInventory
      })
    },
    methods: {
      ...mapActions(['updateTableSource'])
    },
    async beforeMount() {
      await this.updateTableSource({
        source: 'inventorySourceInventories',
        extraFilters: {
          grouped_item_uuid: this.inventory.uuid
        }
      });
    }
  }
</script>

<style lang="scss" scoped>
</style>
